import type { SelectHTMLAttributes } from "react";
import "./form-inputs.style.scss";

export interface SelectOption {
	id: string | number;
	value: string | number;
}

interface SelectBoxProps extends SelectHTMLAttributes<HTMLSelectElement> {
	options: SelectOption[];
}

function SelectBox({ options, disabled, ...selectProps }: SelectBoxProps) {
	return (
		<div className={`select-wrapper ${disabled ? "disabled" : ""}`}>
			<select className="select-box-wrapper" disabled={disabled} {...selectProps}>
				<option value="">- Select -</option>
				{options.map((row, i) => (
					<option value={row.id} key={i}>
						{row.value}
					</option>
				))}
			</select>
		</div>
	);
}
export default SelectBox;
